import { createRouter, createMemoryHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // 사업안내
  {
    path: '/business',
    component: () => import('../views/business/BusinessView.vue'),
    redirect: '/business/overview',
    children: [
      {
        path: 'overview',
        name: 'business-overview',
        component: () => import('../views/business/OverViewTab.vue')
      },
      {
        path: 'company',
        name: 'business-company',
        component: () => import('../views/business/CompanyTab.vue')
      },
      {
        path: 'brand',
        name: 'business-brand',
        component: () => import('../views/business/BrandTab.vue')
      },
      {
        path: 'location',
        name: 'business-location',
        component: () => import('../views/business/LocationTab.vue')
      }
    ]
  },
  // 프리미엄
  {
    path: '/premium',
    component: () => import('../views/premium/PremiumView.vue'),
    redirect: '/premium/location',
    children: [
      {
        path: 'location',
        name: 'premium-location',
        component: () => import('../views/premium/LocationTab.vue')
      },
      {
        path: 'premium8',
        name: 'premium-premium8',
        component: () => import('../views/premium/Premium8Tab.vue')
      }
    ]
  },
  // 단지안내
  {
    path: '/complex',
    component: () => import('../views/complex/ComplexView.vue'),
    redirect: '/complex/design',
    children: [
      {
        path: 'design',
        name: 'complex-design',
        component: () => import('../views/complex/DesignTab.vue')
      },
      {
        path: 'layout',
        name: 'complex-layout',
        component: () => import('../views/complex/LayoutTab.vue')
      },
      {
        path: 'community',
        name: 'complex-community',
        component: () => import('../views/complex/CommunityTab.vue')
      },
      {
        path: 'system',
        name: 'complex-system',
        component: () => import('../views/complex/SystemTab.vue')
      },
      {
        path: 'telecom',
        name: 'complex-telecom',
        component: () => import('../views/complex/TelecomTab.vue')
      }
    ]
  },
  // 분양안내
  {
    path: '/sale',
    component: () => import('../views/sale/SaleView.vue'),
    redirect: '/sale/supply',
    children: [
      {
        path: 'supply',
        name: 'sale-supply',
        component: () => import('../views/sale/SupplyTab.vue')
      }
    ]
  },
  // 세대안내
  {
    path: '/unit',
    component: () => import('../views/unit/UnitView.vue'),
    redirect: '/unit/type',
    children: [
      {
        path: 'type',
        name: 'unit-type',
        component: () => import('../views/unit/TypeTab.vue')
      },
      {
        path: 'interior',
        name: 'unit-interior',
        component: () => import('../views/unit/InteriorTab.vue')
      }
    ]
  },
  // 고객센터
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/support/SupportView.vue')
  },
  // 관리자 페이지
  {
    path: '/adminasanmojong',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  }
]

const router = createRouter({
  history: createMemoryHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.path.startsWith('/business') && from.path.startsWith('/business')) {
      return false
    }
    if (to.path.startsWith('/premium') && from.path.startsWith('/premium')) {
      return false
    }
    if (to.path.startsWith('/complex') && from.path.startsWith('/complex')) {
      return false
    }
    if (to.path.startsWith('/sale') && from.path.startsWith('/sale')) {
      return false
    }
    if (to.path.startsWith('/unit') && from.path.startsWith('/unit')) {
      return false
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 라우터 준비 후 어드민 URL 체크
router.isReady().then(() => {
  if (window.location.hash === '#/adminasanmojong') {
    router.push('/adminasanmojong')
  }
})

export default router